import { POST_CONVERSION_WELCOME_MARKER } from '../../config/constants';
import type { ConversationPair } from '../../services/chatStorage';

export function shouldResetConversationForPostConversion(
    conversationPairs: ConversationPair[]
): boolean {
    if (conversationPairs.length === 0) {
        return false;
    }

    return conversationPairs[0].question?.content !== POST_CONVERSION_WELCOME_MARKER;
}
